import {TFetch} from "../../types";
import reducerStatuses from "../../status";
import {createReducer, PayloadAction} from "@reduxjs/toolkit";
import {
  DONE, FAIL, FETCH, POST, SET,
  SCREENING_EARLY_QUESTIONS_LIST,
  SCREENING_SURVEYS_TEST,
  SCREENING_ONE_TEST,
  SCREENING_ONE_EARLY_TEST,
  SCREENING_TESTS_LIST,
  SCREENING_TESTS_EARLY_LIST,
} from "../../constants";


const initialState: TFetch = {
  testsList: {
    ...reducerStatuses,
    data: [] as any
  },
  testsEarlyList: {
    ...reducerStatuses,
    data: [] as any
  },
  oneTest: {
    ...reducerStatuses,
    data: [] as any
  },
  oneEarlyTest: {
    ...reducerStatuses,
    data: [] as any
  },
  surveysList: {
    ...reducerStatuses,
    data: [] as any
  },
  earlyQuestionList: {
    ...reducerStatuses,
    data: [] as any
  }
}

export default createReducer(initialState, builder =>
  builder
    .addCase(SCREENING_TESTS_LIST + FETCH, (state) => ({
      ...state,
      testsList: {
        ...initialState.testsList,
        loading: true
      }
    }))
    .addCase(SCREENING_TESTS_LIST + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      testsList: {
        ...initialState.testsList,
        success: true,
        data: payload
      }
    }))
    .addCase(SCREENING_TESTS_LIST + FETCH + FAIL, (state) => ({
      ...state,
      testsList: {
        ...initialState.testsList,
        failed: true,
      }
    }))
    .addCase(SCREENING_TESTS_LIST + SET, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      testsList: {
        ...state.testsList,
        data: state.testsList.data.map((testItem:any) => {
            return {
              ...testItem,
              recommendations: payload.recommendations,
              score: payload.score,
            }
          
        })
      }
    }))
    .addCase(SCREENING_TESTS_EARLY_LIST + FETCH, (state) => ({
      ...state,
      testsEarlyList: {
        ...initialState.testsEarlyList,
        loading: true
      }
    }))
    .addCase(SCREENING_TESTS_EARLY_LIST + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      testsEarlyList: {
        ...initialState.testsEarlyList,
        success: true,
        data: payload
      }
    }))
    .addCase(SCREENING_TESTS_EARLY_LIST + FETCH + FAIL, (state) => ({
      ...state,
      testsEarlyList: {
        ...initialState.testsEarlyList,
        failed: true,
      }
    }))
    .addCase(SCREENING_TESTS_EARLY_LIST + SET, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      testsEarlyList: {
        ...state.testsEarlyList,
        data: state.testsEarlyList.data.map((testItem:any) => {
          if(testItem.id == payload.id){
            return {
              ...testItem,
              recommendations: payload.recommendations,
              score: payload.score,
            }
          }

          return testItem;
        })
      }
    }))
    .addCase(SCREENING_ONE_TEST + FETCH, (state) => ({
      ...state,
      oneTest: {
        ...initialState.oneTest,
        loading: true
      }
    }))
    .addCase(SCREENING_ONE_TEST + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneTest: {
        ...initialState.oneTest,
        success: true,
        data: payload
      }
    }))
    .addCase(SCREENING_ONE_TEST + FETCH + FAIL, (state) => ({
      ...state,
      oneTest: {
        ...initialState.oneTest,
        failed: true,
      }
    }))
    .addCase(SCREENING_ONE_EARLY_TEST + FETCH, (state) => ({
      ...state,
      oneEarlyTest: {
        ...initialState.oneEarlyTest,
        loading: true
      }
    }))
    .addCase(SCREENING_ONE_EARLY_TEST + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneEarlyTest: {
        ...initialState.oneEarlyTest,
        success: true,
        data: payload
      }
    }))
    .addCase(SCREENING_ONE_EARLY_TEST + FETCH + FAIL, (state) => ({
      ...state,
      oneEarlyTest: {
        ...initialState.oneEarlyTest,
        failed: true,
      }
    }))
    .addCase(SCREENING_SURVEYS_TEST + FETCH, (state) => ({
      ...state,
      surveysList: {
        ...initialState.surveysList,
        loading: true
      }
    }))
    .addCase(SCREENING_SURVEYS_TEST + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      surveysList: {
        ...initialState.surveysList,
        success: true,
        data: payload
      }
    }))
    .addCase(SCREENING_SURVEYS_TEST + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      surveysList: {
        ...initialState.surveysList,
        failed: true,
        data: payload
      }
    }))
    .addCase(SCREENING_EARLY_QUESTIONS_LIST + POST, (state) => ({
      ...state,
      earlyQuestionList: {
        ...initialState.earlyQuestionList,
        loading: true
      }
    }))
    .addCase(SCREENING_EARLY_QUESTIONS_LIST + POST + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      earlyQuestionList: {
        ...initialState.earlyQuestionList,
        success: true,
        data: payload
      }
    }))
    .addCase(SCREENING_EARLY_QUESTIONS_LIST + POST + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      earlyQuestionList: {
        ...initialState.earlyQuestionList,
        failed: true,
        data: payload
      }
    }))
)